import script from "./oap-promo-bar.vue?vue&type=script&lang=js"
export * from "./oap-promo-bar.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__